export default "__VITE_ASSET__CYa87Pzo__"